<template>
    <div class="distributionSetting">
        <el-tabs v-model="activeName" type="card">
            <el-tab-pane label="招募规则" name="RecruitRule">
                <RecruitRule ref="recruitRule" :data='params'></RecruitRule>
            </el-tab-pane>
            <el-tab-pane label="买家绑定规则" name="BuyerBindingRule">
                <BuyerBindingRule ref="buyerBindingRule" :data='params'></BuyerBindingRule>
            </el-tab-pane>
            <el-tab-pane label="权益设置" name="EquitySetting">
                <EquitySetting :innerid="innerid" :data='params' ref="equitySetting"></EquitySetting>
            </el-tab-pane>
            <el-tab-pane label="公众号通知设置" name="TencentInformSetting">
                <TencentInformSetting :data='params' ref="tencentInformSetting"></TencentInformSetting>
            </el-tab-pane>
        </el-tabs>
        <div class="btnBox padding-20">
            <el-button @click.native="cancel">取消</el-button>
            <el-button type="primary" @click.native="saveVerify">保存</el-button>
        </div>
    </div>
</template>
<script>
import EquitySetting from './distributionSetting/EquitySetting'
import BuyerBindingRule from './distributionSetting/BuyerBindingRule'
import RecruitRule from './distributionSetting/RecruitRule'
import TencentInformSetting from './distributionSetting/TencentInformSetting'
import {updatedDistributionSetting, getDistributionMsg} from '@/api/distribution'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'distributionSetting',
    data() {
        return {
            activeName: 'EquitySetting',
            params: {}
        }
    },
    props: ['innerid'],
    created() {
        this.getMsg()
    },
    methods: {
        saveVerify() {
            let arr = JSON.parse(JSON.stringify(this.$refs.equitySetting.params.promoterlevelList))
            let lowDirectProportion = arr[0].diectbrokeragerate // 普通推广员直接佣金
            let lowUndirectProportion = arr[0].secondbrokeragerate // 普通推广员间接佣金
            let highDirectProportion = arr[1].diectbrokeragerate // 高级推广员直接佣金
            let highUndirectProportion = arr[1].secondbrokeragerate // 高级推广员间接佣金
            let rule = false
            let num = true
            arr.forEach(obj => {
                rule = false
                if (obj.totalclientcount.num < 0) {
                    this.$message.error('累计推广客户需要大于0')
                    num = false
                    return
                }
                if (obj.totalordermoney.num < 0) {
                    this.$message.error('累计推广金额需要大于0')
                    num = false
                    return
                }
                if (obj.totalpromotercount.num < 0) {
                    this.$message.error('累计邀请推广员需要大于0')
                    num = false
                    return
                }
                if (obj.totalpromotercount.num || obj.totalordermoney.num || obj.totalclientcount.num) {
                    rule = true
                }
                // if (!rule) {
                //     console.log(rule)
                //     this.$message.error('请设置升级规则')
                //     return
                // }
            })
            if (highUndirectProportion > 0 && rule && num) {
                if (highDirectProportion > lowDirectProportion && highUndirectProportion > lowUndirectProportion) {
                    if (arr.length === 3) {
                        let superDirectProportion = arr[2].diectbrokeragerate // 超级推广员直接佣金
                        let superUndirectProportion = arr[2].secondbrokeragerate // 超级推广员间接佣金
                        if ((highDirectProportion > lowDirectProportion && highUndirectProportion > lowUndirectProportion) && (superDirectProportion > highDirectProportion && superUndirectProportion > highUndirectProportion)) {
                            this.saveDistributionSetting()
                            this.$refs.equitySetting.params.promoterlevelList.forEach(obj => {
                                obj.edit = false
                            })
                        } else {
                            this.$message.error('高等级推广员的佣金比例，不能小于低等级的推广员')
                        }
                    } else {
                        this.saveDistributionSetting()
                        this.$refs.equitySetting.params.promoterlevelList.forEach(obj => {
                            obj.edit = false
                        })
                    }
                } else {
                    this.$message.error('高等级推广员的佣金比例，不能小于低等级的推广员')
                }
            } else {
                if (highUndirectProportion < 0) {
                    this.$message.error('高级推广员的直接佣金必须大于0')
                }
                if (rule) {
                    this.$message.error('请设置一个升级规则')
                }
                if (num) {
                    this.$message.error('累计推广客户、累计邀请推广员和累计推广金额需要大于0')
                }
            }
        },
        saveDistributionSetting() {
            this.setLoading(true)
            for (let key in this.$refs) {
                this.params = Object.assign(this.params, this.$refs[key].params)
            }
            this.params.promoterlevelList.forEach(obj => {
                obj.edit = false
            })
            this.params.promoterlevelList = JSON.parse(JSON.stringify(this.params.promoterlevelList))
            this.params.promoterlevelList.forEach(obj => {
                delete obj.edit
                if (obj.totalclientcount) {
                    obj.totalclientcount = obj.totalclientcount.num
                }
                if (obj.totalordermoney) {
                    obj.totalordermoney = obj.totalordermoney.num
                }
                if (obj.totalpromotercount) {
                    obj.totalpromotercount = obj.totalpromotercount.num
                }
            })
            this.params.promoterlevelList = JSON.stringify(this.params.promoterlevelList)
            updatedDistributionSetting({
                data: this.params,
                success: data => {
                    this.setLoading(false)
                    this.$message({
                        type: 'success',
                        message: '保存成功'
                    })
                    this.getMsg()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        getMsg() {
            this.setLoading(true)
            getDistributionMsg({
                data: {},
                success: data => {
                    this.setLoading(false)
                    this.params = data.data
                    this.params.promoterlevelList = JSON.stringify(this.params.promoterlevelList)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        cancel() {
            this.getMsg()
        },
        ...mapActions([
            'setLoading'
        ])
    },
    components: {
        EquitySetting, BuyerBindingRule, RecruitRule, TencentInformSetting
    }
}
</script>
<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .distributionSetting{
        .el-tabs{
            min-height: 500px;
        }
        .btnBox{
            line-height: 20px;
            text-align: center;
            box-sizing: border-box;
            margin-top: 10px;
        }
    }
</style>